// =============================================
// SERVICIO DE PARÁMETROS
// Maneja todas las peticiones al API de parámetros
// =============================================

import api from './api';

const parameterService = {
  // PARAMETRIZACIÓN: Obtener todos los parámetros
  getAll: async (category = null) => {
    const params = category ? { category } : {};
    const response = await api.get('/parameters', { params });
    return response.data;
  },

  // PARAMETRIZACIÓN: Obtener parámetro por key
  getByKey: async (key) => {
    const response = await api.get(`/parameters/key/${key}`); // Corregido: agregado /key/
    return response.data;
  },

  // PARAMETRIZACIÓN: Obtener parámetro público (sin autenticación)
  getPublic: async (key) => {
    const response = await api.get(`/parameters/public/${key}`);
    return response.data;
  },

  // PARAMETRIZACIÓN: Obtener categorías
  getCategories: async () => {
    const response = await api.get('/parameters/categories/list'); // Corregido: agregado /list
    return response.data;
  },

  // PARAMETRIZACIÓN: Crear parámetro
  create: async (parameterData) => {
    const response = await api.post('/parameters', parameterData);
    return response.data;
  },

  // PARAMETRIZACIÓN: Actualizar parámetro
  update: async (id, parameterData) => {
    const response = await api.put(`/parameters/${id}`, parameterData);
    return response.data;
  },

  // PARAMETRIZACIÓN: Eliminar parámetro
  delete: async (id) => {
    const response = await api.delete(`/parameters/${id}`);
    return response.data;
  },
};

export default parameterService;
